const moment = require('moment')
const state = {
  siteConfigs: {
    lastUpdateAt: null,
    data: {
      MAINTAINING: false, // 是否正在维护
      MAINTAINING_REASON: '', // 维护说明语
      TITLE: '思创工程保证信息管理系统v1.0',
      SUBTITLE: '思创网联（北京）科技发展有限公司',
      COPYRIGHT_HOLDER: '思创网联（北京）科技发展有限公司',
      SITE_START_YEAR: 2020,
      SITE_ICP_NO: '京ICP备16022875号',
      COPYRIGHT_HOLDER_HOME: 'https://www.sclinker.com',
      HOTLINE: '400-811-5272',
      TECH_SUPPORT: '',
      TECH_SUPPORT_HOME: '',
      WELCOME_BACKGROUND_IMAGE_URL: 'bg_01.jpg',
      ENABLE_SMS_LOGIN: false, // 是否允许短信登录
      ENABLE_REGISTER: true, // 是否开放注册
      FORCE_CHANGE_PWD_ON_FIRST_LOGIN: false, // 是否强制初次登录修改密码
      ENABLE_E_GUA: true, // 是否启用电子保函
      LOGIN_LAYOUT_NAME: 'Center',
      THEME: '', // 主题
      SHOW_PUBLISHED_GUARANTORS: true, // 是否展示保证人公示名单
      NEED_TERMINATE_UPLOAD_REPORT: true, // 是否需要解除保函上传竣工报告
      ENABLE_PREAUDIT_GUARANTEE: true, // 是否开启保函预审功能
      PREAUDIT_GUARANTEE_NEED_SIGN: false, // 预审保函是否需要CA签名
      AUDIT_GUARANTEE_NEED_SIGN: true, // 审核保函是否需要CA签名
      AUDIT_TERMINATE_NEED_SIGN: true, // 审核解除保函是否需要CA签名
      TERMINATE_NEED_SIGN: true, // 申请解除保函是否需要CA签名
      AUDIT_RENEWAL_NEED_SIGN: true, // 审核续保是否需要CA签名
      RENEWAL_NEED_SIGN: true, // 申请续保是否需要CA签名
      SUBMIT_GUARANTEE_NEED_SIGN: true, // 申请保函是否需要CA签名
      ENABLE_CLAIM: false, // 是否开启代偿功能
      ENABLE_GEN_SUPV_CLAIM_GUA: false, // 是否允许总监管人代偿保函
      ENABLE_GEN_SUPV_MNG_GUA: true, // 是否允许总监管人管理保函
      ENABLE_SUPV_MNG_GUA: true, // 是否允许监管人管理保函
      ENABLE_GEN_SUPV_MNG_GUARANTOR: true, // 是否允许总监管人管理保证人
      ENABLE_SUPV_MNG_GUARANTOR: true, // 是否允许监管人管理保证人
      ENABLE_GUARANTOR_REGISTER: true, // 是否允许承保人自主注册
      GUARANTOR_REGISTER_ATTACHMENT_REQUIREMENTS: [
        {
          name: '法定代表人授权委托书',
          formats: 'pdf,jpg,jpeg,png,tif,tiff',
          fileSizeLimit: 5 * 1024, // kb
          fileCountLimit: 1,
          required: true
        },
        {
          name: '法定代表人身份证扫描件',
          formats: 'pdf,jpg,jpeg,png,tif,tiff',
          fileSizeLimit: 5 * 1024, // kb
          fileCountLimit: 2,
          required: true
        },
        {
          name: '委托人身份证扫描件',
          formats: 'pdf,jpg,jpeg,png,tif,tiff',
          fileSizeLimit: 5 * 1024, // kb
          fileCountLimit: 2,
          required: false
        },
        {
          name: '营业执照',
          formats: 'pdf,jpg,jpeg,png,tif,tiff',
          fileSizeLimit: 5 * 1024, // kb
          fileCountLimit: 2,
          required: true
        },
        {
          name: '公司章程',
          formats: 'pdf',
          fileSizeLimit: 5 * 1024, // kb
          fileCountLimit: 1,
          required: true
        },
        {
          name: '开户许可证',
          formats: 'pdf,jpg,jpeg,png,tif,tiff',
          fileSizeLimit: 5 * 1024, // kb
          fileCountLimit: 1,
          required: true
        },
        {
          name: '董事会或股东会决议',
          formats: 'pdf',
          fileSizeLimit: 5 * 1024, // kb
          fileCountLimit: 1,
          required: true
        },
        {
          name: '办公地点房产证或房屋租赁协议',
          formats: 'pdf',
          fileSizeLimit: 5 * 1024, // kb
          fileCountLimit: 1,
          required: true
        },
        {
          name: '开展工程保证业务的相关管理制度',
          formats: 'pdf',
          fileSizeLimit: 5 * 1024, // kb
          fileCountLimit: 1,
          required: true
        },
        {
          name: '开展工程保证业务流程图',
          formats: 'pdf,jpg,jpeg,png,tif,tiff',
          fileSizeLimit: 5 * 1024, // kb
          fileCountLimit: 1,
          required: true
        },
        {
          name: '工程风险评价和风险管控制度',
          formats: 'pdf',
          fileSizeLimit: 5 * 1024, // kb
          fileCountLimit: 1,
          required: true
        },
        {
          name: '开展工程保证业务使用的印章图鉴',
          formats: 'pdf,jpg,jpeg,png,tif,tiff',
          fileSizeLimit: 5 * 1024, // kb
          fileCountLimit: 1,
          required: true
        },
        {
          name: '工程担保业务承诺书',
          formats: 'pdf,jpg,jpeg,png,tif,tiff',
          fileSizeLimit: 5 * 1024, // kb
          fileCountLimit: 1,
          required: true
        },
        {
          name: '行业自律公约书',
          formats: 'pdf,jpg,jpeg,png,tif,tiff',
          fileSizeLimit: 5 * 1024, // kb
          fileCountLimit: 1,
          required: true
        }
      ], // 承保人注册时要求上传附件清单
      GUARANTOR_BANK_REGISTER_ATTACHMENT_REQUIREMENTS: [
        {
          name: '甘肃省工程保证人备案申请表',
          formats: 'pdf,jpg,jpeg,png,tif,tiff',
          fileSizeLimit: 5 * 1024, // kb
          fileCountLimit: 1,
          required: true
        },
        {
          name: '公司营业执照扫描件',
          formats: 'pdf,jpg,jpeg,png,tif,tiff',
          fileSizeLimit: 5 * 1024, // kb
          fileCountLimit: 1,
          required: true
        },
        {
          name: '法定代表人授权委托书（身份证原件复印留存）',
          formats: 'pdf,jpg,jpeg,png,tif,tiff',
          fileSizeLimit: 5 * 1024, // kb
          fileCountLimit: 1,
          required: true
        },
        {
          name: '设立分支机构文件及营业执照',
          formats: 'pdf,jpg,jpeg,png,tif,tiff',
          fileSizeLimit: 5 * 1024, // kb
          fileCountLimit: 5,
          required: true
        },
        {
          name: '开展工程保证业务的相关管理制度（加盖公章）',
          formats: 'pdf',
          fileSizeLimit: 5 * 1024, // kb
          fileCountLimit: 10,
          required: true
        },
        {
          name: '工程风险评价和风险管控制度（加盖公章）',
          formats: 'pdf',
          fileSizeLimit: 5 * 1024, // kb
          fileCountLimit: 10,
          required: true
        },
        {
          name: '开展工程保证业务流程图（加盖公章）',
          formats: 'pdf,jpg,jpeg,png,tif,tiff',
          fileSizeLimit: 5 * 1024, // kb
          fileCountLimit: 1,
          required: true
        },
        {
          name: '开展工程保证业务使用的印章图鉴',
          formats: 'pdf,jpg,jpeg,png,tif,tiff',
          fileSizeLimit: 5 * 1024, // kb
          fileCountLimit: 1,
          required: true
        },
        {
          name: '工程担保业务承诺书（加盖公章）',
          formats: 'pdf,jpg,jpeg,png,tif,tiff',
          fileSizeLimit: 5 * 1024, // kb
          fileCountLimit: 1,
          required: true
        },
        {
          name: '甘肃省工程保证行业自律公约书（加盖公章）',
          formats: 'pdf,jpg,jpeg,png,tif,tiff',
          fileSizeLimit: 5 * 1024, // kb
          fileCountLimit: 1,
          required: true
        }
      ], // 银行承保人注册时要求上传附件清单
      // 资料清单实例模板下载地址
      GUARANTOR_REGISTER_ATTACHMENT_SAMPLE_URL: 'https://gsacs-demo.oss-cn-beijing.aliyuncs.com/%E8%B5%84%E6%96%99%E6%B8%85%E5%8D%95-%E6%8B%85%E4%BF%9D%E5%85%AC%E5%8F%B8.rar',
      GUARANTOR_BANK_REGISTER_ATTACHMENT_SAMPLE_URL: 'https://gsacs-demo.oss-cn-beijing.aliyuncs.com/%E8%B5%84%E6%96%99%E6%B8%85%E5%8D%95-%E6%8B%85%E4%BF%9D%E5%85%AC%E5%8F%B8.rar',
      GUARANTOR_REGISTER_ATTACHMENT_SAMPLET_TEXT: '资料清单模板',
      GUARANTEE_RENEWAL_ATTACHMENT_REQUIREMENTS: [
        {
          name: '续保合同',
          formats: 'pdf,jpg,jpeg,png,tif,tiff',
          maxLength: 5 * 1024, // kb
          fileCountLimit: 5,
          required: true
        },
        {
          name: '续保保费转账凭证',
          formats: 'pdf,jpg,jpeg,png,tif,tiff',
          maxLength: 5 * 1024, // kb
          fileCountLimit: 5,
          required: true
        },
        {
          name: '续保发票',
          formats: 'pdf,jpg,jpeg,png,tif,tiff',
          maxLength: 5 * 1024, // kb
          fileCountLimit: 5,
          required: true
        }
      ], // 续保时要求上传附件清单
      GUARANTEE_RENEWAL_ENABLED: true,
      GUARANTEE_CLAIM_ATTACHMENT_REQUIREMENTS: [
        {
          name: '代偿通知书',
          formats: 'pdf,jpg,jpeg,png,tif,tiff',
          maxLength: 5 * 1024, // kb
          fileCountLimit: 5,
          required: true
        },
      ], // 发起代偿时要求上传附件清单
    }
  },
  menuGeneralSupervisor: {
    lastUpdateAt: null,
    data: []
  },
  menuSupervisor: {
    lastUpdateAt: null,
    data: []
  },
  menuGuarantor: {
    lastUpdateAt: null,
    data: []
  }
}
const mutations = {
  SET_CONFIGS (state, data) {
    Object.assign(state.siteConfigs.data, data)
    console.log(state.siteConfigs.data, data)
    state.siteConfigs.lastUpdateAt = new Date().toISOString()
    window.localStorage.setItem('site-configs', JSON.stringify(state.siteConfigs))
  },
  SET_MENU_GENERAL_SUPERVISOR (state, data) {
    state.menuGeneralSupervisor.data = data
    console.log(state.menuGeneralSupervisor.data, data)
    state.menuGeneralSupervisor.lastUpdateAt = new Date().toISOString()
    window.localStorage.setItem('menu-general-supervisor', JSON.stringify(state.menuGeneralSupervisor))
  },
  SET_MENU_SUPERVISOR (state, data) {
    state.menuSupervisor.data = data
    console.log(state.menuSupervisor.data, data)
    state.menuSupervisor.lastUpdateAt = new Date().toISOString()
    window.localStorage.setItem('menu-supervisor', JSON.stringify(state.menuSupervisor))
  },
  SET_MENU_GUARANTOR (state, data) {
    state.menuGuarantor.data = data
    console.log(state.menuGuarantor.data, data)
    state.menuGuarantor.lastUpdateAt = new Date().toISOString()
    window.localStorage.setItem('menu-guarantor', JSON.stringify(state.menuGuarantor))
  },
  UPDATE_THEME (state) {
    let localStorageTheme = window.localStorage.getItem('current_theme')
    if (localStorageTheme) {
      if (localStorageTheme !== 'DEFAULT') {
        updateTheme(localStorageTheme)
      }
      return localStorageTheme
    } else {
      window.localStorage.setItem('current_theme', state.siteConfigs && state.siteConfig.data && state.siteConfigs.data.THEME ? state.siteConfigs.data.THEME : 'DEFAULT')
      updateTheme(state.siteConfigs && state.siteConfig.data && state.siteConfigs.data.THEME ? state.siteConfigs.data.THEME : 'DEFAULT')
      return state.siteConfigs && state.siteConfig.data && state.siteConfigs.data.THEME ? state.siteConfigs.data.THEME : 'DEFAULT'
    }
    // console.log(state.siteConfigs.data.THEME)
    // if (state.siteConfigs && state.siteConfigs.data && state.siteConfigs.data.THEME) {
    //   window.localStorage.setItem('current_theme', state.siteConfigs.data.THEME)
    //   if (state.siteConfigs.data.THEME !== 'DEFAULT') {
    //     updateTheme(state.siteConfigs.data.THEME)
    //   }
    //   return state.siteConfigs.data.THEME
    // } else {
    //   if (localStorageTheme) {
    //     if (localStorageTheme !== 'DEFAULT') {
    //       updateTheme(localStorageTheme)
    //     }
    //     return localStorageTheme
    //   } else {
    //     window.localStorage.setItem('current_theme', state.siteConfigs && state.siteConfig.data && state.siteConfigs.data.THEME ? state.siteConfigs.data.THEME : 'DEFAULT')
    //     updateTheme(state.siteConfigs && state.siteConfig.data && state.siteConfigs.data.THEME ? state.siteConfigs.data.THEME : 'DEFAULT')
    //     return state.siteConfigs && state.siteConfig.data && state.siteConfigs.data.THEME ? state.siteConfigs.data.THEME : 'DEFAULT'
    //   }
    // }
  },
}
const actions = {
  setConfigs ({ commit }, data) {
    commit('SET_CONFIGS', data)
  },
  setMenuGeneralSupervisor ({ commit }, data) {
    commit('SET_MENU_GENERAL_SUPERVISOR', data)
  },
  setMenuSupervisor ({ commit }, data) {
    commit('SET_MENU_SUPERVISOR', data)
  },
  setMenuGuarantor ({ commit }, data) {
    commit('SET_MENU_GUARANTOR', data)
  },
  updateTheme ({ commit }, data) {
    commit('UPDATE_THEME', data)
  },
}
const getters = {
  sysConfigs: (state) => {
    try {
      let localStorageSysConfigs = JSON.parse(window.localStorage.getItem('site-configs'))
      if (localStorageSysConfigs && localStorageSysConfigs.data && localStorageSysConfigs.data.TITLE) {
        if (!localStorageSysConfigs.lastUpdateAt || moment().diff(moment(localStorageSysConfigs.lastUpdateAt), 'hours') >= 1) {
          // 过期
          console.log('1-1')
          window.localStorage.removeItem('site-configs')
          updateSysConfigs().then((cfg) => {
            window.location.reload()
            console.log(cfg)
            return cfg
          }).catch(() => {
            return null
          })
        } else {
          if (localStorageSysConfigs.data.MAINTAINING === true) {
            if (window.location.href.indexOf('maintaining.html') < 0) {
              window.location.href = '/maintaining.html'
            }
          }
          return localStorageSysConfigs.data
        }
      } else {
        if (!state.siteConfigs.lastUpdateAt || moment().diff(moment(state.siteConfigs.lastUpdateAt), 'hours') >= 1) {
          // 过期
          console.log('2-1')
          console.log(state.siteConfigs)
          window.localStorage.removeItem('site-configs')
          updateSysConfigs().then((cfg) => {
            window.location.reload()
            console.log(cfg)
            return cfg
          }).catch(() => {
            return null
          })
        } else {
          if (state.siteConfigs.data.MAINTAINING === true) {
            if (window.location.href.indexOf('maintaining.html') < 0) {
              window.location.href = '/maintaining.html'
            }
          }
          console.log('2-2')
          return state.siteConfigs.data
        }
      }
    } catch (err) {
      console.log('err')
      window.localStorage.removeItem('site-configs')
      updateSysConfigs().then((cfg) => {
        window.location.reload()
        console.log(cfg)
        return cfg
      }).catch(() => {
        return null
      })
    }
  },
  menuGeneralSupervisor: (state) => {
    return new Promise((resolve) => {
      try {
        let localStorageSysConfigs = JSON.parse(window.localStorage.getItem('menu-general-supervisor'))
        if (localStorageSysConfigs && localStorageSysConfigs.data) {
          if (!localStorageSysConfigs.lastUpdateAt || moment().diff(moment(localStorageSysConfigs.lastUpdateAt), 'hours') >= 1) {
            // 过期
            console.log('1-1')
            window.localStorage.removeItem('menu-general-supervisor')
            updateMenu('GENERAL_SUPERVISOR').then((cfg) => {
              // window.location.reload()
              console.log(cfg)
              mutations.SET_MENU_GENERAL_SUPERVISOR(state, cfg)
              resolve(cfg)
            }).catch(() => {
              resolve()
            })
          } else {
            resolve(localStorageSysConfigs.data)
          }
        } else {
          if (!state.menuGeneralSupervisor.lastUpdateAt || moment().diff(moment(state.menuGeneralSupervisor.lastUpdateAt), 'hours') >= 1) {
            // 过期
            console.log('2-1')
            console.log(state.menuGeneralSupervisor)
            window.localStorage.removeItem('menu-general-supervisor')
            updateMenu('GENERAL_SUPERVISOR').then((cfg) => {
              // window.location.reload()
              console.log(cfg)
              mutations.SET_MENU_GENERAL_SUPERVISOR(state, cfg)
              resolve(cfg)
            }).catch(() => {
              resolve()
            })
          } else {
            console.log('2-2')
            resolve(state.menuGeneralSupervisor.data)
          }
        }
      } catch (err) {
        console.log('err')
        window.localStorage.removeItem('menu-general-supervisor')
        updateMenu('GENERAL_SUPERVISOR').then((cfg) => {
          // window.location.reload()
          mutations.SET_MENU_GENERAL_SUPERVISOR(state, cfg)
          console.log(cfg)
          resolve(cfg)
        }).catch(() => {
          resolve()
        })
      }
    })
  },
  menuSupervisor: (state) => {
    return new Promise((resolve) => {
      try {
        let localStorageSysConfigs = JSON.parse(window.localStorage.getItem('menu-supervisor'))
        if (localStorageSysConfigs && localStorageSysConfigs.data) {
          if (!localStorageSysConfigs.lastUpdateAt || moment().diff(moment(localStorageSysConfigs.lastUpdateAt), 'hours') >= 1) {
            // 过期
            console.log('1-1')
            window.localStorage.removeItem('menu-supervisor')
            updateMenu('SUPERVISOR').then((cfg) => {
              // window.location.reload()
              console.log(cfg)
              mutations.SET_MENU_SUPERVISOR(state, cfg)
              resolve(cfg)
            }).catch(() => {
              resolve()
            })
          } else {
            resolve(localStorageSysConfigs.data)
          }
        } else {
          if (!state.menuSupervisor.lastUpdateAt || moment().diff(moment(state.menuSupervisor.lastUpdateAt), 'hours') >= 1) {
            // 过期
            console.log('2-1')
            console.log(state.menuSupervisor)
            window.localStorage.removeItem('menu-supervisor')
            updateMenu('SUPERVISOR').then((cfg) => {
              // window.location.reload()
              console.log(cfg)
              mutations.SET_MENU_SUPERVISOR(state, cfg)
              resolve(cfg)
            }).catch(() => {
              resolve()
            })
          } else {
            resolve(state.menuSupervisor.data)
          }
        }
      } catch (err) {
        console.log('err')
        window.localStorage.removeItem('menu-supervisor')
        updateMenu('SUPERVISOR').then((cfg) => {
          // window.location.reload()
          mutations.SET_MENU_SUPERVISOR(state, cfg)
          console.log(cfg)
          resolve(cfg)
        }).catch(() => {
          resolve()
        })
      }
    })
  },
  menuGuarantor: (state) => {
    return new Promise((resolve) => {
      try {
        let localStorageSysConfigs = JSON.parse(window.localStorage.getItem('menu-guarantor'))
        if (localStorageSysConfigs && localStorageSysConfigs.data) {
          if (!localStorageSysConfigs.lastUpdateAt || moment().diff(moment(localStorageSysConfigs.lastUpdateAt), 'hours') >= 1) {
            // 过期
            console.log('1-1')
            window.localStorage.removeItem('menu-guarantor')
            updateMenu('GUARANTOR').then((cfg) => {
              // window.location.reload()
              console.log(cfg)
              mutations.SET_MENU_GUARANTOR(state, cfg)
              resolve(cfg)
            }).catch(() => {
              resolve()
            })
          } else {
            resolve(localStorageSysConfigs.data)
          }
        } else {
          if (!state.menuGuarantor.lastUpdateAt || moment().diff(moment(state.menuGuarantor.lastUpdateAt), 'hours') >= 1) {
            // 过期
            console.log('2-1')
            console.log(state.menuGuarantor)
            window.localStorage.removeItem('menu-guarantor')
            updateMenu('GUARANTOR').then((cfg) => {
              // window.location.reload()
              console.log(cfg)
              mutations.SET_MENU_GUARANTOR(state, cfg)
              resolve(cfg)
            }).catch(() => {
              resolve()
            })
          } else {
            console.log('2-2')
            resolve(state.menuGuarantor.data)
          }
        }
      } catch (err) {
        console.log('err')
        window.localStorage.removeItem('menu-guarantor')
        updateMenu('GUARANTOR').then((cfg) => {
          // window.location.reload()
          mutations.SET_MENU_GUARANTOR(state, cfg)
          console.log(cfg)
          resolve(cfg)
        }).catch(() => {
          resolve()
        })
      }
    })
  },
  currentTheme: state => {
    let localStorageTheme = window.localStorage.getItem('current_theme')
    if (state.siteConfigs && state.siteConfig.data && state.siteConfigs.data.THEME) {
      window.localStorage.setItem('current_theme', state.siteConfigs.data.THEME)
      if (state.siteConfigs.data.THEME !== 'DEFAULT') {
        updateTheme(state.siteConfigs.data.THEME)
      }
      return state.siteConfigs.data.THEME
    } else {
      if (localStorageTheme) {
        if (localStorageTheme !== 'DEFAULT') {
          updateTheme(localStorageTheme)
        }
        return localStorageTheme
      } else {
        window.localStorage.setItem('current_theme', state.siteConfigs && state.siteConfigs.data && state.siteConfigs.data.THEME ? state.siteConfigs.data.THEME : 'DEFAULT')
        updateTheme(state.siteConfigs && state.siteConfig.data && state.siteConfigs.data.THEME ? state.siteConfigs.data.THEME : 'DEFAULT')
        return state.siteConfigs && state.siteConfig.data && state.siteConfigs.data.THEME ? state.siteConfigs.data.THEME : 'DEFAULT'
      }
    }
  },
  GUARANTOR_RREGISTER_ATTACHMENT_REQUIREMENTS: () => {
    return new Promise((resolve, reject) => {
      getConfigKeyValueFromServer(`GUARANTOR_RREGISTER_ATTACHMENT_REQUIREMENTS`).then((res) => {
        console.log(res, JSON.parse(res))
        let configsStr = res
        let configs = JSON.parse(configsStr)
        if (configs) {
          resolve(configs)
        }
        resolve()
      }).catch(err => {
        reject(err)
      })
    })
  },
  GUARANTOR_APPRAISE_ATTACHMENT_REQUIREMENTS: () => {
    return new Promise((resolve, reject) => {
      getConfigKeyValueFromServer(`GUARANTOR_APPRAISE_ATTACHMENT_REQUIREMENTS`).then((res) => {
        if (!res) {
          resolve([])
        }
        console.log(res, JSON.parse(res))
        let configsStr = res
        let configs = JSON.parse(configsStr)
        if (configs) {
          resolve(configs)
        }
        resolve()
      }).catch(err => {
        reject(err)
      })
    })
  }
}

const updateTheme = (themeName) => {
  let existLink
  let links = document.head.getElementsByTagName('link')
  for (let i = 0; i < links.length; i++) {
    if (links[i].id === 'customTheme') {
      existLink = links[i]
    }
  }
  if (existLink) {
    existLink.href = `./static/css/iview_${themeName.toLowerCase()}.css`
  } else {
    let link = document.createElement('link')
    link.id = 'customTheme'
    link.rel = 'stylesheet'
    link.type = 'text/css'
    link.href = `./static/css/iview_${themeName.toLowerCase()}.css`
    document.head.appendChild(link)
  }
}

const updateSysConfigs = () => {
  console.log('update configs')
  return new Promise((resolve, reject) => {
    try {
      let configsStr = ''
      getConfigKeyValueFromServer('SITE_CONFIGS').then((res) => {
        console.log('site-configs', res, JSON.parse(res))
        configsStr = res
        let configs = JSON.parse(configsStr)
        if (configs) {
          mutations.SET_CONFIGS(state, configs)
          document.title = configs.TITLE
          window.localStorage.setItem('current_theme', configs.THEME)
          if (configs.MAINTAINING === true) {
            if (window.location.href.indexOf('maintaining.html') < 0) {
              window.location.href = '/maintaining.html'
            }
          }
          console.log(configs)
          resolve(configs)
        }
        resolve()
      }).catch(err => {
        throw err
      })
    } catch (err) {
      console.log(err)
      reject(err)
    }
  })
}

const updateMenu = (role) => {
  console.log('update menu')
  return new Promise((resolve, reject) => {
    try {
      let configsStr = ''
      getConfigKeyValueFromServer(`MENU_${role}`).then((res) => {
        console.log(res, JSON.parse(res))
        configsStr = res
        let configs = JSON.parse(configsStr)
        if (configs) {
          resolve(configs)
        }
        resolve()
      }).catch(err => {
        throw err
      })
    } catch (err) {
      console.log(err)
      reject(err)
    }
  })
}

const getConfigKeyValueFromServer = (key) => {
  return new Promise((resolve, reject) => {
    let Api = require('./../api/Api').default
    Api.KVS.getKVS(key).then(value => {
      resolve(value)
    }).catch((err) => {
      reject(err)
    })
  })
}

// 不要忘记把state, mutations等暴露出去。
export default {
  state,
  mutations,
  actions,
  getters
}
